import { VehicleFuelType } from "@/api-schema-enums";
import { VEHICLE_FUEL_TYPE_LABELS } from "@/common/helpers/vehicle-type-labels";
import i18next from "i18next";
import { BaseFilterProps, Filter, FilterData } from "../_types";
import { FilterComponent } from "../base-filter";

function getVehicleFuelTypeOptions(): { id: VehicleFuelType; name: string }[] {
  const lang = i18next.language === "de" ? "de" : "en";
  return Object.entries(VEHICLE_FUEL_TYPE_LABELS)
    .filter(([key]) => Object.values(VehicleFuelType).includes(key as VehicleFuelType))
    .map(([id, labels]) => ({ id: id as VehicleFuelType, name: labels[lang] }));
}

export class VehicleFuelTypeFilter extends Filter<Record<string, never>, Record<string, never>> {
  readonly id: string = "fuelType";
  readonly labelSingular = "masterdata:FuelType";
  readonly labelPlural = "masterdata:FuelType";
  readonly placeholder = "masterdata:SelectFuelType";
  readonly searchPlaceholder = "masterdata:SearchFuelType";
  readonly emptyText = "masterdata:NoFuelTypeFound";
  body = {};
  parameters = {};

  constructor({ id }: { id?: string } = {}) {
    super();
    if (id) this.id = id;
  }

  getData(): FilterData {
    return {
      options: getVehicleFuelTypeOptions(),
      isLoading: false,
      error: null,
    };
  }

  render(props: BaseFilterProps) {
    return <FilterComponent filter={this} {...props} />;
  }
}
